import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCourseStore } from '../store/CourseStore'
import { useMetaStore } from '../store/MetaStore'
import { useRoundStore } from '../store/RoundStore'
import EventSignInView from '../views/EventSignInView'

const EventSignInController = () => {
  const [eventCode, setEventCode] = useState('')
  const errorMsg = useMetaStore((state) => state.errorMsg)
  const setErrorMsg = useMetaStore((state) => state.setErrorMsg)
  const navigate = useNavigate()

  const setOrgId = useMetaStore((state) => state.setOrgId)
  const setEventId = useMetaStore((state) => state.setEventId)
  const setApiKey = useMetaStore((state) => state.setApiKey)
  const setFinalized = useMetaStore((state) => state.setFinalized)
  const setAdminEntry = useMetaStore((state) => state.setAdminEntry)
  const setRoundDate = useRoundStore((state) => state.setRoundDate)
  const setCourse = useCourseStore((state) => state.setCourse)
  const initRound = useMetaStore((state) => state.initRound)
  const [events, setEvents] = useState([])
  const [selectedEventId, setSelectedEventId] = useState('')
  const [loadingEvents, setLoadingEvents] = useState(true)

  useEffect(() => {
    if (window.location.hostname === 'admin.gsk.nevast.com') {
      setAdminEntry(true)
      navigate('/login')
      return
    }

    setErrorMsg('')
    const orgId = useMetaStore.getState().orgId

    if (!orgId) {
      console.warn('No orgId found for fetching events')
      setLoadingEvents(false)
      return
    }

    const year = new Date().getFullYear()
    axios.get(`/gskapi/event/org/${orgId}/year/${year}`)
      .then((response) => {
        setEvents(response.data)
        if (response.data && response.data.length > 0) {
          setSelectedEventId(response.data[0].eventId)
          setEventId(response.data[0].eventId)
        }
        setLoadingEvents(false)
      })
      .catch((error) => {
        console.error('Error fetching events:', error)
        setErrorMsg('Failed to load events for the current year')
        setLoadingEvents(false)
      })
  }, [])

  const onSubmit = async () => {
    try {
      setErrorMsg('')
      initRound()
      axios
        .post('/gskapi/meta/validatecode', { eventId: selectedEventId, eventCode })
        .then((response) => {
          const { orgId, apiKey, course, roundDate, finalized } = response.data

          if (apiKey && course && roundDate) {
            setOrgId(orgId)
            setApiKey(apiKey.apiKey)
            setCourse(course)
            setRoundDate(roundDate)
            setFinalized(finalized || false)

            // Set axios global header
            axios.defaults.headers.common['Api-Token'] = apiKey.apiKey

            navigate(`/event`)
          } else {
            setErrorMsg('Could not obtain required round information')
          }
        })
        .catch((error) => {
          console.error('Error validating event code:', error)
          setErrorMsg('Error validating event code')
        })
    } catch (error) {
      console.error('Error onSubmit in EventSignInController:', error)
      setErrorMsg('Error validating event code')
    }
  }

  return (
    <EventSignInView
      events={events}
      selectedEventId={selectedEventId}
      setSelectedEventId={(id) => {
        setSelectedEventId(id)
        setEventId(id)
        setErrorMsg('')
      }}
      loadingEvents={loadingEvents}
      eventCode={eventCode}
      setEventCode={setEventCode}
      onSubmit={onSubmit}
      errorMsg={errorMsg}
      setErrorMsg={setErrorMsg}
    />
  )
}

export default EventSignInController
